import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
function Loader() {
  return <Spinner animation='grow' variant='primary' />;
}

export default Loader;
